module.exports = __webpack_public_path__ + "img/eres_8_steps_v2.1ddef49f.png";